/**
 * Centralized page transition animation variants for framer-motion.
 * Used across all layout files to animate only the main content area.
 */

export const pageVariants = {
  initial: {
    opacity: 0,
    y: 8,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -8,
  },
};

export const pageTransition = {
  duration: 0.25,
  ease: [0.25, 0.1, 0.25, 1.0],
};

/** Reduced-motion safe variant — only fades, no movement */
export const reducedPageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const reducedPageTransition = {
  duration: 0.15,
  ease: 'linear',
};
